import { render } from "./menuBar.vue?vue&type=template&id=4f959502&scoped=true&ts=true"
import script from "./menuBar.vue?vue&type=script&lang=ts"
export * from "./menuBar.vue?vue&type=script&lang=ts"

import "./menuBar.vue?vue&type=style&index=0&id=4f959502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f959502"]])

export default __exports__